import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useFetch } from "@/lib/content";

export default function BrandMark({ footer = false, linkTo = true }) {
  const { data: settings } = useFetch("/content/settings");
  const logo = footer ? settings?.footer_logo_url || settings?.logo_url : settings?.logo_url;

  useEffect(() => {
    const fav = settings?.favicon_url;
    if (!fav) return;
    let link = document.head.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "icon");
      document.head.appendChild(link);
    }
    link.setAttribute("href", fav);
  }, [settings?.favicon_url]);

  const mark = logo ? (
    <img
      data-testid={footer ? "footer-logo" : "header-logo"}
      src={logo}
      alt="RenB Solutions"
      className={`w-auto cursor-pointer ${footer ? "h-8" : "h-9 md:h-10"}`}
    />
  ) : (
    <span className="flex items-baseline gap-1">
      <span className={`font-serif text-3xl font-semibold tracking-tight md:text-4xl ${footer ? "text-2xl text-paper/90 md:text-3xl" : ""}`}>
        RenB
      </span>
      <span className={`inline-block bg-progress ${footer ? "h-1.5 w-1.5" : "h-2 w-2"}`} aria-hidden="true" />
      {!footer && (
        <span className="hidden text-[10px] font-bold uppercase tracking-[0.3em] text-slategray sm:inline sm:ml-2">
          Solutions
        </span>
      )}
      {footer && <span className="ml-2 text-xs uppercase tracking-[0.2em] text-paper/60">Solutions</span>}
    </span>
  );

  if (!linkTo) return mark;
  return (
    <Link to="/" data-testid="brand-mark" aria-label="RenB Solutions home" className="inline-flex cursor-pointer items-center">
      {mark}
    </Link>
  );
}
